import { Language } from '@dentalux/ui-library-core/src/type/Translations'
import { format, Locale } from 'date-fns'
import { toZonedTime } from 'date-fns-tz'
import { DATE_FORMATS } from 'src/config/constants'

export const formatDate = (timestamp: string, lang: Language, locale: Locale): string => {
  try {
    const date = getDateFromTimestamp(timestamp)
    const formatString = DATE_FORMATS.WEEKDAY_DAY_MONTH_YEAR_TIME[lang]
    const formattedDate = format(date, formatString, { locale })

    return formattedDate
  } catch (error) {
    console.error(`Error formatting date: ${error}`)
    return 'Date not available'
  }
}

export const getDateFromTimestamp = (timestamp: string) => {
  /*
    DCD clinic encodes url automatically which replaces '+' sign with whitespace.
    For offset timestamps we need to have that '+', that's why we are replacing the whitespace with it.
  */

  if (!timestamp) {
    return new Date() // Return current date to avoid spamming errors when appointmentDate parameter is missing in the URL (caused by e2e tests)
  }

  if (timestamp.includes(' ')) {
    timestamp = timestamp.replace(/ /g, '+')
  }

  const date = toZonedTime(timestamp, 'Europe/Berlin')

  return date
}

export const getDateWithWeekDayAndTime = (date: Date) => {
  const dateWithWeekDay = format(date, 'EEEE, dd MMMM yyyy')
  const time = format(date, DATE_FORMATS.TIME)

  return { dateWithWeekDay, time }
}

export const getFormattedDate = (date: Date, lang: Language, locale: Locale, argFormat?: string) => {
  const dateFormat = argFormat || DATE_FORMATS.DAY_MONTH_YEAR[lang] || DATE_FORMATS.DAY_MONTH_YEAR.de

  return format(date, dateFormat, { locale })
}

export const getFormattedTime = (date: Date) => {
  return format(date, DATE_FORMATS.TIME)
}
